import { mapGetters } from 'vuex'

export default {
  name: 'success-register',
  computed: {
    ...mapGetters({
      agentCode: 'auth/agentCode',
    }),
  },
  created() {
    document.getElementById('html').classList.add('hide')
  },
}
